// extracted by mini-css-extract-plugin
export var table = "_ym-0";